<template>
    <div class="stickers__sticker-list">
        <Loader
            v-if="stickersIsLoading"
            class="da-ui--color__loader"
        />

        <div
            v-if="!stickersIsLoading"
            class="stickers__sticker-list__scroll-wrapper"
            v-bar
        >
            <div>
                <div
                    class="stickers__sticker-item da-ui--color__count"
                    v-for="(sticker, i) in stickers"
                    :key="i"
                    @mousedown="addSticker(sticker)"
                    :style="{backgroundImage: `url(${ sticker.url })`}"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ACTIONS as ACTIONS_STICKERS } from '../../store/stickers'

import Loader from '../../components/ui/loader'

export default {
    name: 'List',

    components: {
        Loader,
    },

    props: ['data', 'isLoading'],

    computed: {
        ...mapGetters({
            stickers: 'stickers',
            stickersIsLoading: 'stickersIsLoading',
            widget: 'widget',
        }),
    },

    mounted() {
        this.$store.dispatch(ACTIONS_STICKERS.FETCH_STICKER_BALANCE)
    },

    methods: {
        addSticker(sticker) {
            this.$store.dispatch(ACTIONS_STICKERS.ADD_STICKER, {sticker})
        },
    },
}
</script>

<style lang='scss' scoped>
.stickers {
    &__sticker-list {
        padding: 54px 0 0;
        width: 100%;
        height: 100%;

        &__scroll-wrapper {
            width: 100%;
            height: 100%;
        }
    }

    &__sticker-item {
        margin: 10px;
        width: 106px;
        float: left;
        cursor: pointer;
        background-color: transparent;
        border-radius: 4px;
        position: relative;
        background-size: 80%;
        background-position: center center;
        background-repeat: no-repeat;
        transition: all .2s;

        &_disabled {
            opacity: .5;
            pointer-events: none;
        }

        &:hover {
            background-color: rgba(232, 232, 232, 1);
        }

        &:after {
            display: block;
            content: '';
            padding-top: 100%;
        }
    }

    &__sticker-count {
        background-color: rgba(245, 125, 7, 1);
        border-radius: 10px;
        font-size: 12px;
        line-height: 20px;
        padding: 0 6px;
        color: #fff;
        position: absolute;
        top: 10px;
        right: 8px;
        user-select: none;
        overflow: hidden;
        transition: all .1s;

        span {
            display: block;
        }
    }
}

.slide-fade-enter-active {
  transition: all .1s ease;
}
.slide-fade-leave-active {
  transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter {
  transform: translateY(20px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
</style>